// Formato y helpers de presentacion de Reportes Inteligentes. Todo lo que
// convierte un numero o una fila en algo que se lee en pantalla.
//
// La logica de calculo NO va aca: vive en src/utils/reportesInteligentes.js.

import { sanitizeProductDisplayName } from '../../utils/productLabels';

export const PIE_COLORS = ['#51A7FD', '#3FF2AA', '#F05A57', '#FFB454', '#A88BFF', '#FF7AAA', '#22D3EE', '#94A3B8'];

export const formatMoney = (value) =>
  Number(value || 0).toLocaleString('es-AR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2,
  });

export const formatInt = (value) => Number(value || 0).toLocaleString('es-AR');

// Cantidad con hasta 2 decimales (insumos/mermas pueden ser fraccionarios: kg, etc.).
export const formatQty = (value) =>
  Number(value || 0).toLocaleString('es-AR', { maximumFractionDigits: 2 });

export const formatPercent = (value) => `${Number(value || 0).toLocaleString('es-AR', { minimumFractionDigits: 1, maximumFractionDigits: 1 })}%`;

export const formatDateShort = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return '-';
  // timeZone:'UTC' es clave: el POS usa "hora forjada" (local como UTC),
  // igual que VentasHistorial. Sin esto, en Argentina la fecha aparece un día antes.
  return date.toLocaleDateString('es-AR', { day: '2-digit', month: '2-digit', timeZone: 'UTC' });
};

export const safeName = (raw, fallback = 'Sin nombre') =>
  sanitizeProductDisplayName(raw || fallback, fallback);

export const formatDateLong = (date) => {
  if (!date) return '-';
  const d = date instanceof Date ? date : new Date(date);
  if (Number.isNaN(d.getTime())) return '-';
  return d.toLocaleDateString('es-AR', { day: '2-digit', month: 'short', year: 'numeric' });
};

// Clasificación de movimientos de stock (mismo criterio que InventarioMovimientos).
export const classifyTipoMovimiento = (raw) => {
  const lower = String(raw || '').trim().toLowerCase();
  if (lower.includes('transfer')) return 'transferencia';
  if (lower.includes('ingreso')) return 'ingreso';
  if (lower.includes('egreso') || lower.includes('venta') || lower.includes('salida')) return 'egreso';
  return 'otro';
};

export const MOVIMIENTO_TONE = {
  ingreso: 'bg-emerald-50 text-emerald-700 border-emerald-100',
  egreso: 'bg-rose-50 text-rose-700 border-rose-100',
  transferencia: 'bg-blue-50 text-blue-700 border-blue-100',
  otro: 'bg-slate-100 text-slate-600 border-slate-200',
};

// Detecta una merma/desperdicio a partir del tipo + motivo del movimiento.
// No existe tabla dedicada de mermas: se reconocen por palabra clave.
export const isMermaMovimiento = (m) => {
  const blob = `${m?.tipo || ''} ${m?.motivo || ''}`.toLowerCase();
  return /merma|desperdici|rotura|vencid|deterior|descarte|baja/.test(blob);
};

export const margenColorClass = (pct) =>
  pct < 0 ? 'text-rose-600' : pct < 15 ? 'text-amber-600' : 'text-emerald-600';
